import {html} from 'lit';
import {
	selectBaseProfile,
	selectBaseProfileIsSatisfied,
	selectLuminary,
	selectLuminaryIsSatisfied,
	selectZone,
	selectZoneIsSatisfied,
	selectProjectName,
	selectCentralPowerControl,
	selectCentralPowerControlIsSatisfied,
	selectLightProfileLocation,
	selectLightProfileLocationIsSatisfied, selectLightProfileIsSatisfied,
} from '../selectors';

import {fetchLightProfileLocation} from './lightProfileSlice';

export const baseProfileOptions = [
	{
		id: 'BiologicalRed',
		image: '/line-assets/img/slx-clp-diagrams-tiles-bio-red.png',
		specimg: '/line-assets/img/lightprofiles/Bio_Red-Summer.jpg',
		specimg2: '/line-assets/img/lightprofiles/Bio_Red-Winter.jpg',
		video: '/line-assets/video/Bio_red.mp4',
		label: {
			de: 'Biologisches Rot',
			en: 'Biological Red',
			fr: 'Biological Red',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'Das Lichtprofil »Biologisches Rot« verbindet Sicherheit mit Natur- und Insektenschutz an besonders sensiblen Orten. Dieses Profil passt eigenständig die Lichtfarbe und Lichtintensität von Leuchten an: in langen Winternächten wird energetisch optimiertes Licht verwendet. In warmen Monaten, in denen Insekten aktiv sind, rote Lichtwellen, die für Insekten unsichtbar sind.',
			en: 'The »Biological Red« light profile combines safety with biodiversity protection for particularly sensitive areas. This profile independently adjusts the light colour and light intensity of luminaires: in long winter nights, energetically optimized light is used. In warm months, when insects are active, red light waves that are invisible to insects.',
			fr: 'Le profil lumineux "Biological Red" associe la sécurité à la protection de la biodiversité dans les zones particulièrement sensibles. Ce profil permet de régler indépendamment la couleur et l\'intensité de la lumière des luminaires : pendant les longues nuits d\'hiver, une lumière optimisée sur le plan énergétique est utilisée. Pendant les mois chauds, lorsque les insectes sont actifs, des ondes lumineuses rouges invisibles pour les insectes sont utilisées.',
		},
		link: {
			de: 'circulare-lichtprofile/biologisch-rot',
			en: 'circular-light-profiles/biological-red',
			fr: 'profils-lumineux-circulaires/biological-red',
		}
	},

	{
		id: 'BiologicalWhite',
		image: '/line-assets/img/slx-clp-diagrams-tiles-bio-white.png',
		specimg: '/line-assets/img/lightprofiles/Bio_White-Summer.jpg',
		specimg2: '/line-assets/img/lightprofiles/Bio_White-Winter.jpg',
		video: '/line-assets/video/Bio_white.mp4',
		label: {
			de: 'Biologisch Weiß',
			en: 'Biological White',
			fr: 'Biological White',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'Das Lichtprofil »Biologisches Weiß« verbindet Sicherheit mit Natur- und Insektenschutz.Dieses Profil passt eigenständig die Lichtfarbe und Lichtintensität von Leuchten an: In langen Winternächten wird energetisch optimiertes Licht mit 3000 K verwendet. In den warmen Monaten, in denen Insekten aktiv sind, werden Insektenschonende 2200 K eingesetzt.',
			en: 'The »Biological White« light profile combines safety with biodiversity protection. This profile independently adjusts the light colour and light intensity of luminaires: In long winter nights, energy-optimized light with 3000 K is used. In the warm months, when insects are active, insect-friendly 2200 K is used.',
			fr: 'Le profil lumineux "Biological White" allie sécurité et protection de la biodiversité. Ce profil permet de régler indépendamment la couleur et l\'intensité de la lumière des luminaires : pendant les longues nuits d\'hiver, on utilise une lumière optimisée sur le plan énergétique avec une température de couleur de 3000K. Pendant les mois chauds, lorsque les insectes sont actifs, on utilise une lumière respectueuse des insectes avec une température de couleur de 2200K.',
		},
		link: {
			de: 'circulare-lichtprofile/biologisch-weiss',
			en: 'circular-light-profiles/biological-white',
			fr: 'profils-lumineux-circulaires/biological-white',
		}
	},
	{
		id: 'AdjustingWhite',
		image: '/line-assets/img/slx-clp-diagrams-tiles-adjusting-white.png',
		specimg: '/line-assets/img/lightprofiles/Dyn_Int-1_2.jpg',
		specimg2: '/line-assets/img/lightprofiles/Dyn_Int-3_4.jpg',
		video: '/line-assets/video/Adjusting_white.mp4',
		label: {
			de: 'Dynamische Intensität',
			en: 'Adjusting White',
			fr: 'Adjusting White',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'Das Lichtprofil »Dynamische Intensität« verbindet Orientierung für Menschen, Dunkelzonen für die Natur und Effizienz. Dieses Profil passt im Jahres- und Nachtverlauf eigenständig die Lichtintensität an, um Insekten, Pflanzen und den schwarzen Nachthimmel zu schützen und Energie zu sparen.',
			en: 'The »Adjusting White« light profile combines orientation for people, dark zones for nature and energy efficiency. This profile independently adjusts light intensity over the course of the year and night to protect insects, plants and the black night sky and save energy.',
			fr: 'Le profil lumineux "Adjusting White" combine l\'orientation pour les personnes, les zones sombres pour la nature et l\'efficacité énergétique. Ce profil ajuste indépendamment l\'intensité lumineuse au cours de l\'année et de la nuit pour protéger les insectes, les plantes et le ciel nocturne noir et économiser de l\'énergie.',
		},
		link: {
			de: 'circulare-lichtprofile/dynamische-intensitaet',
			en: 'circular-light-profiles/adjusting-white',
			fr: 'profils-lumineux-circulaires/adjusting-white',
		}
	},
	{
		id: 'DynamicAmbience',
		image: '/line-assets/img/slx-clp-diagrams-tiles-dynamic-ambiance.png',
		specimg: '/line-assets/img/lightprofiles/Dyn_Amb-1_2.jpg',
		specimg2: '/line-assets/img/lightprofiles/Dyn_Amb-3_4.jpg',
		video: '/line-assets/video/Dynamic_ambience.mp4',
		label: {
			de: 'Dynamisches Ambiente',
			en: 'Dynamic Ambience',
			fr: 'Dynamic Ambience',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'Das Lichtprofil »Dynamisches Ambiente« verbindet eine dreidimensionale Atmosphäre, Orientierung und Dark Sky im urbanen Raum. Dieses Profil passt eigenständig die horizontale sowie vertikale Lichtverteilung an und verändert die Lichtintensität, um zu den aktiven Zeiten von Menschen das Raumgefühl und die Wahrnehmung von Gesichtern zu verbessern und in den späten Abendstunden den Nachthimmel und nachtaktive Tiere zu schützen und Energie zu sparen.',
			en: 'The »Dynamic Ambience« lighting profile combines a three-dimensional atmosphere, orientation and Dark Sky in urban spaces. This profile independently adjusts the horizontal as well as vertical light distribution and changes the light intensity to improve the sense of space and the perception of faces during the active times of people, and to protect the night sky and nocturnal animals and save energy during the late evening hours.',
			fr: 'Le profil d\'éclairage "Dynamic Ambiance" associe l’ambiance, l‘orientation et le ciel étoilé dans les espaces urbains. Ce profil ajuste indépendamment la distribution horizontale et verticale de la lumière et modifie l\'intensité lumineuse pour améliorer la sensation d\'espace et la perception des visages pendant les périodes d\'activité des personnes, tout en protégeant le ciel nocturne et les animaux et en économisant de l\'énergie pendant les heures tardives de la soirée.',
		},
		link: {
			de: 'circulare-lichtprofile/dynamisches-ambiente',
			en: 'circular-light-profiles/dynamic-ambiance',
			fr: 'profils-lumineux-circulaires/dynamic-ambiance',
		}
	},
	{
		id: 'DynamicPath',
		image: '/line-assets/img/slx-clp-diagrams-tiles-dynamic-path.png',
		specimg: '/line-assets/img/lightprofiles/Dyn_Path-1_2.jpg',
		specimg2: '/line-assets/img/lightprofiles/Dyn_Path-3_4.jpg',
		video: '/line-assets/video/Dynamic_Path.mp4',
		label: {
			de: 'Dynamisch Horizontal',
			en: 'Dynamic Path',
			fr: 'Dynamic Path',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'Das Lichtprofil »Dynamisch Horizontal« verbindet Atmosphäre, Orientierung, Dark Sky und Effizienz. Dieses Profil modelliert die horizontale Lichtverteilung zwischen schmal und breit sowie die Lichtintensität, um unterschiedliche Lichterlebnisse abhängig von der Tageszeit und der Personenfrequenz zu schaffen und Energie zu sparen.',
			en: 'The light profile »Dynamic Path« combines atmosphere, orientation, dark sky and efficiency. This profile models the horizontal light distribution between narrow and wide, as well as the light intensity, to create different lighting experiences depending on the time of day and people frequency, and to save energy.',
			fr: 'Le profil lumineux "Dynamic Path" combine atmosphère, orientation, ciel noir et efficacité. Ce profil modifie la distribution horizontale de la lumière, ainsi que l\'intensité lumineuse, afin de créer différentes expériences d\'éclairage en fonction de l\'heure de la journée et de la fréquentation des lieux, et d\'économiser de l\'énergie.',
		},
		link: {
			de: 'circulare-lichtprofile/dynamic-path',
			en: 'circular-light-profiles/dynamic-path',
			fr: 'profils-lumineux-circulaires/dynamic-path',
		}
	},
];
export const zoneOptions = [
	{
		id: 'Culture',
		image: '/line-assets/img/culture.jpg',
		label: {
			de: 'Kultur',
			en: 'Culture',
			fr: 'zone urbaine',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'In Innenstadtbereichen ist die menschliche Aktivität und Frequenz am höchsten. Hier findet Kultur, Austausch, Arbeit und Zusammenkommen statt. Egal ob Anwohner, Touristen, Geschäftsleute, Arbeitnehmer und Partygänger, Fußgänger, Fahrradfahrer, Autos und Busse. Oftmals bis in die späten Nachtstunden.',
			en: 'In inner city areas, human activity and frequency is at its highest. This is where culture, exchange, work and coming together take place. It’s residents, tourists, business people, party people, pedestrians, cyclists, cars and buses. Often until late at night.',
			fr: 'Dans les centres-villes, l\'activité et la fréquentation sont importantes. C\'est là que prennent place la culture, les échanges, le travail et les rencontres. On y trouve des habitants, des touristes, des hommes d\'affaires, des fêtards, des piétons, des cyclistes, des voitures et des bus. Souvent jusque tard dans la nuit.',
		}
	},
	{
		id: 'Mix',
		image: '/line-assets/img/mix.jpg',
		label: {
			de: 'Mix',
			en: 'Mix',
			fr: 'zone péri-urbaine',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'In der Mischzone gehen Menschen nach Hause, um mit ihren Familien zusammen zu sein und sich in der Nacht auszuruhen. Gleichzeitig sind aber auch nachts und morgens vereinzelt Menschen unterwegs, die auf Arbeit gehen. Kinder laufen oder fahren zur Schule und benötigen Licht für ihre Sicherheit und Orientierung. In der Mischzone nimmt die menschliche Frequenz früher als in der Innenstadt ab. Die Biodiversität nimmt stärker zu.',
			en: 'In the mixed zone, people go home to be with their families and rest at night. At the same time there are also occasional people on the road at night and in the morning they go to work. Children walk or drive to school and need light for their safety and orientation. In the mixed zone, human frequency decreases earlier than in the inner city whereas biodiversity increases.',
			fr: 'Dans la zone péri-urbaine, les gens rentrent chez eux pour retrouver leur famille et se reposer la nuit. Dans le même temps, des personnes circulent occasionnellement sur la route la nuit et le matin pour aller travailler. Les enfants se rendent à l\'école et ont besoin de lumière pour leur sécurité et leur orientation. Dans cette zone, la fréquentation des lieux diminue plus tôt que dans le centre-ville, tandis que l’activité de la faune augmente.',
		}

	},
	{
		id: 'Nature',
		image: '/line-assets/img/nature.jpg',
		label: {
			de: 'Natur',
			en: 'Nature',
			fr: 'Nature',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'In Natur - und Landschaftsräume ist Biodiversität am größten. Hier ist das Wohn- und Schlafzimmer Pflanzen und Tieren. Die Frequenz von Menschen ist gering. Hier stehen die Bedürfnisse der Tier- und Pflanzenwelt im Fokus.',
			en: 'Biodiversity play the most important role in natural and landscape areas. These are the living rooms and bedrooms of plants and animals. Human frequency is low. Focus lies on the needs of flora and fauna.',
			fr: 'La biodiversité joue le rôle le plus important dans les zones naturelles et paysagères. Ce sont les pièces à vivre et les chambres à coucher des plantes et des animaux. L’activité humaine y est faible. L’accent est mis sur les besoins de la flore et de la faune.',
		}
	}
];
export const centralPowerControlOptions = [
	{
		id: 'on',
		label: {
			de: 'Zentrale Abschaltung am Tag',
			en: 'Central shutdown',
			fr: 'Arrêt centralisé',
		},
		info: {
			de: 'Die Stromzufuhr wird tagsüber abgeschaltet',
			en: 'The power supply is switched off during the day',
			fr: 'L’alimentation électrique est coupée pendant la journée',
		}
	},
	{
		id: 'off',
		label: {
			de: 'Ununterbrochene Stromzufuhr',
			en: 'Uninterrupted power supply',
			fr: 'Alimentation électrique ininterrompue',
		},
		info: {
			de: 'Die Stromzufuhr wird tagsüber nicht abgeschaltet',
			en: 'The power supply is not switched off during the day',
			fr: 'L’alimentation électrique n’est pas coupée pendant la journée',
		}
	},
];

export const luminaryOptions = [
	{
		id: 'Avanza',
		family: 'Avanza',
		productModel: 'Avanza',
		image: '/line-assets/img/luminaires/Avanza_450_1.jpg',
		imageWhite: '/line-assets/img/luminaires/Avanza_450_2.jpg',
		label: {
			de: 'Avanza',
			en: 'Avanza',
			fr: 'Avanza',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'Ein wertvoller Beitrag für die Zukunft. Avanza sorgt für gutes Sehen und ein einzigartiges Erscheinungsbild für Straßen und Plätze. Dank der präzisen Optik erzeugt Avanza kein störendes Streulicht und schützt somit den nächtlichen Himmel vor Lichtverschmutzung.',
			en: 'A valuable contribution to the future. Avanza provides good vision and a unique appearance for streets and squares. Thanks to its precise optics, Avanza does not produce disturbing stray light and thus protects the night sky from light pollution.',
			fr: 'Une contribution précieuse pour l\'avenir. Avanza assure une bonne vision et un aspect unique pour les rues et les places. Grâce à son optique précise, Avanza ne produit pas de lumière parasite gênante et protège ainsi le ciel nocturne de la pollution lumineuse.',
		},
		availableForLightProfiles: ['BiologicalWhite', 'BiologicalRed', 'AdjustingWhite'],
		features: [
			'root::CX_Region',
			'root::HS_HousingColour',
			'root::LE_OpticalVersion_1',
			'root::LE_LightDistribution_1',
			'root::LE_ColourTemperature_1',
			'root::LE_OpticalVersion_1',
			'root::LE_DimmingLevel_1',
			'root::HS_HousingSize',
			'root::HS_Base',
			'root::LE_LightEngineModuleSize_1',
			'root::EB_Zhaga_1',
			'root::EB_ConstantLumenTechnology_1',
			'root::EB_ControlNoWire_1',
			'root::EB_ControlWire_1'
		],
		widgets: []
	},
	{
		id: 'tal',
		family: 'Tal',
		productModel: 'Tal',
		image: '/line-assets/img/luminaires/tal_example.png',
		imageWhite: '/line-assets/img/luminaires/tal_example.png',
		label: {
			de: 'Tal',
			en: 'Tal',
			fr: 'Tal',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'Solide, zukunftssichere Licht- und Designqualität im Stadtraum. Tal garantiert wirtschaftliches Licht für Straßen und Plätze. Dank der präzisen Optik erzeugt Tal kein störendes Streulicht und schützt somit den nächtlichen Himmel vor Lichtverschmutzung.',
			en: 'Solid, future-proof lighting and design quality in urban spaces. Tal guarantees economical light for streets and squares. Thanks to precise optics, Tal does not produce disturbing stray light and thus protects the night sky from light pollution.',
			fr: 'Une qualité d\'éclairage et de design solide et à l\'épreuve du temps dans l\'espace urbain. Tal garantit un éclairage économique des rues et des places. Grâce à son optique précise, Tal ne produit pas de lumière parasite gênante et protège ainsi le ciel nocturne de la pollution lumineuse.',
		},
		availableForLightProfiles: ['BiologicalWhite', 'BiologicalRed', 'AdjustingWhite'],
		features: [
			'root::CX_Region',
			'root::HS_HousingColour',
			'root::HS_HousingSize',
			'root::LE_OpticalVersion_1',
			'root::LE_LightDistribution_1',
			'root::LE_ColourTemperature_1',
			'root::HS_Base',
			'root::LE_LightEngineModuleSize_1',
			'root::EB_ElectricalProtectionClass_1',
			'root::HS_HousingPowerConnection',
			'root::LE_DimmingLevel_1',
			'root::EB_Zhaga_1',
			'root::HS_HousingPowerConnection',
			'root::EB_ConstantLumenTechnology_1',
			'root::EB_ControlNoWire_1',
			'root::EB_ControlWire_1'
		],
		widgets: []
	},
	{
		id: 'saturn',
		family: 'Saturn',
		productModel: 'SaturnPoleTop',
		image: '/line-assets/img/luminaires/Saturn-RGB_3.jpg',
		imageWhite: '/line-assets/img/luminaires/Saturn-RGB_2.jpg',
		label: {
			de: 'Saturn',
			en: 'Saturn',
			fr: 'Saturn',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'Für klassische bis zu moderner Architektur. Die Leuchten der Saturn Familie sind besonders für wohnnahe Bereiche geschaffen, in denen der Wunsch nach behaglichem Licht besteht. Mit der Tritec Sky Optik setzt Licht­akzente, die individuelle Details wie Formen, Farben und Texturen erleb­bar macht und gleichzeitig den Nachthimmel vor Streulicht schützt.',
			en: 'For classical to modern architecture. The luminaires in the Saturn family are especially made for areas close to homes where there is a desire for comfortable light. Tritec Sky optics set lighting accents that bring individual details such as shapes, colors and textures to life while protecting the night sky from stray light.',
			fr: 'Pour une architecture classique ou moderne. Les luminaires de la famille Saturn sont particulièrement adaptés aux espaces proches de l\'habitat, où l\'on souhaite une lumière confortable. L\'optique Tritec Sky crée des accents lumineux qui permettent de découvrir des détails individuels tels que les formes, les couleurs et les textures, tout en protégeant le ciel nocturne de la lumière diffuse.',
		},
		availableForLightProfiles: ['BiologicalWhite', 'BiologicalRed', 'AdjustingWhite'],
		features: [
			/*
			'HS_HousingColour',
			'LE_LightDistribution_1',
			'LE_OpticalVersion_1',
			'HS_HousingSize',
			'HS_Base',
			'LE_LightEngineModuleSize_1',
			'EB_ElectricalProtectionClass_1',
			*/
			'root::CX_Region',
			'root::HS_HousingColour',
			'root::LE_OpticalVersion_1',
			'root::LE_LightDistribution_1',
			'root::HS_HousingSize',
			'root::HS_Base',
			'root::LE_LightEngineModuleSize_1',
			'root::LE_ColourTemperature_1',
			'root::LE_ReflectorColour_1',
			'root::HS_LightEmission',
			'root::LE_DimmingLevel_1',
			'root::EB_Zhaga_1',
			'root::HS_HousingPowerConnection',
			'root::EB_ConstantLumenTechnology_1',
			'root::EB_ControlNoWire_1',
			'root::EB_ControlWire_1'
		],
		widgets: []
	},
	{
		id: 'aya',
		family: 'Aya',
		productModel: 'Aya',
		image: '/line-assets/img/luminaires/aya_example.png',
		imageWhite: '/line-assets/img/luminaires/aya_white_example.png',
		label: {
			de: 'Aya',
			en: 'Aya',
			fr: 'Aya',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'Form follows magic - \n' +
				'Eine neue Leuchtengeneration mit intelligenter High-End Lichttechnologie trifft auf ein Design, das die Magie der Natur zum Vorbild nimmt.',
			en: 'Form follows magic –\n' +
				'A new generation of luminaires where intelligent, high-end lighting technology meets design modelled on the magic of nature.',
			fr: 'La forme succède à la magie –\n' +
				'Une nouvelle génération de luminaires dotés d\'une technologie d\'éclairage intelligente et de qualité rencontre un design inspiré de la magie de la nature.',
		},
		availableForLightProfiles: ['BiologicalWhite', 'BiologicalRed', 'AdjustingWhite'],
		features: [
			'root::CX_Region',
			'root::HS_HousingSize',
			'root::HS_HousingColour',
			'root::HS_HousingCoating',
			'root::LE_OpticalVersion_1',
			'root::LE_LightDistribution_1',
			'root::LE_ColourTemperature_1',
			'root::HS_Base',
			'root::LE_LightEngineModuleSize_1',
			'root::EB_ElectricalProtectionClass_1',
			'root::HS_HousingPowerConnection',
			'root::LE_DimmingLevel_1',
			'root::EB_Zhaga_1',
			'root::EB_ConstantLumenTechnology_1',
			'root::EB_ControlNoWire_1',
			'root::EB_ControlWire_1'
			/*
						'EB_ConstantLumenTechnology_1',
						'EB_ControlNoWire_1',
						'EB_ControlWire_1',
						'EB_Wattage_1',
						'HS_HousingSize',
						'HS_ColourPriceCategory',
						'HS_HousingPowerConnection',
						'HS_HousingZhaga',
						'LE_LuminousFlux_1',
						'LE_ReflectorColour_1',
						'HS_CircularBaseProfile',
						'LE_LightEngineModuleSize_1'
			*/

		],
		widgets: [
			html`
				<model-select></model-select>`
		]
	},
	{
		id: 'yloo',
		family: 'Yloo',
		productModel: 'Yloo',
		image: '/line-assets/img/luminaires/yloo.png',
		imageWhite: '/line-assets/img/luminaires/yloo.png',
		label: {
			de: 'Yloo',
			en: 'Yloo',
			fr: 'Yloo',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'Elegant, effizient und rundum funktional für ein harmonisches Erscheinungsbild. Die Bandbreite an Bauformen und Montagevarianten ermöglichen es, den Stadtraum in seinen unterschiedlichen Ausprägungen mit einem System zu beleuchten. Die Optiken von Yloo lenken das Licht ohne Streulicht exakt dorthin, wo es benötigt wird und schonen so die Natur. ',
			en: 'Elegant, efficient and all-round functional for a harmonious appearance. The range of designs and mounting options make it possible to illuminate urban space in its various forms with a single system. Yloo\'s optics direct the light exactly where it is needed without stray light, thus protecting nature. ',
			fr: 'Élégant, efficace et entièrement fonctionnel pour une apparence harmonieuse. L\'éventail des formes de construction et des variantes de montage permet d\'éclairer l\'espace urbain dans ses différentes expressions avec un seul système. Les optiques d\'Yloo dirigent la lumière sans dispersion exactement là où elle est nécessaire et préservent ainsi la nature.',
		},
		availableForLightProfiles: ['AdjustingWhite', 'DynamicPath'],
		features: [
			'root::CX_Region',
			'root::HS_HousingSize',
			'root::HS_HousingColour',
			'root::HS_HousingCoating',
			'root::LE_OpticalVersion_1',
			'root::LE_LightDistribution_1',
			'root::LE_ColourTemperature_1',
			'root::HS_Base',
			'root::LE_LightEngineModuleSize_1',
			'root::EB_ElectricalProtectionClass_1',
			'root::HS_HousingPowerConnection',
			'root::LE_DimmingLevel_1',
			'root::EB_Zhaga_1',
			'root::EB_ConstantLumenTechnology_1',
			'root::EB_ControlNoWire_1',
			'root::EB_ControlWire_1'
			/*
						'EB_ConstantLumenTechnology_1',
						'EB_ControlNoWire_1',
						'EB_ControlWire_1',
						'EB_Wattage_1',
						'HS_HousingSize',
						'HS_ColourPriceCategory',
						'HS_HousingPowerConnection',
						'HS_HousingZhaga',
						'LE_LuminousFlux_1',
						'LE_ReflectorColour_1',
						'HS_CircularBaseProfile',
						'LE_LightEngineModuleSize_1'
			*/

		],
		widgets: [
			html`
				<model-select></model-select>`
		]
	},
	{
		id: 'lanova',
		family: 'Lanova',
		productModel: 'LanovaCatenary',
		image: '/line-assets/img/luminaires/Lanova-pendant_3-RGB.jpg',
		imageWhite: '/line-assets/img/luminaires/Lanova-pendant_2-RGB.jpg',
		imageModelSpecific: {
			LanovaCatenary: {
				image: '/line-assets/img/luminaires/Lanova-pendant_3-RGB.jpg',
				imageWhite: '/line-assets/img/luminaires/Lanova-pendant_2-RGB.jpg',
			},
			LanovaPoleTop: {
				image: '/line-assets/img/luminaires/Lanova-top-RGB_black_3.jpg',
				imageWhite: '/line-assets/img/luminaires/Lanova-top-RGB_white_3.jpg',
			},
		},
		label: {
			de: 'Lanova',
			en: 'Lanova',
			fr: 'Lanova',
		},
		info: {
			de: '',
			en: '',
			fr: '',
		},
		description: {
			de: 'Luftig-leichtes Erscheinungsbild in zeitlosem Design. Ob als Mast- oder Seilpendelleuchte — Lanova bringt luftige Eleganz in jede Umgebung. Das optische System sorgt für eine komfortable Entblendung und eine effiziente Lichtlenkung.',
			en: 'Airy, light appearance in a timeless design. Whether as a pole or cable suspended luminaire, Lanova brings airy elegance to any environment. The optical system provides comfortable glare control and efficient light direction.',
			fr: 'Une apparence aérienne et légère dans un design intemporel. Qu\'il s\'agisse d\'un luminaire sur mât ou d\'une suspension à câble, Lanova apporte une élégance aérienne dans chaque environnement. Le système optique assure un anti-éblouissement confortable et un guidage efficace de la lumière.',
		},
		availableForLightProfiles: ['AdjustingWhite', 'DynamicAmbience', 'DynamicPath'],
		features: [
			'root::CX_Region',
			'root::HS_HousingColour',
			'root::LE_LightDistribution_1',
			'root::LE_LightEngineModuleSize_1',
			'root::LE_ColourTemperature_1',
			'root::EB_ElectricalProtectionClass_1',
			'root::EB_ConstantLumenTechnology_1',
			'root::HS_HousingSize',
			'root::HS_HousingCoating',
			'root::HS_Base',
			'root::HS_HousingPowerConnection',
			'root::LE_DimmingLevel_1',
			'root::EB_Zhaga_1',
			'root::EB_ControlNoWire_1',
			'root::EB_ControlWire_1',
			'root::HS_LightEmission',
			'root::HS_LightEmissionCA',
			'root::HS_UpLight',
			/*
			'HS_HousingSize',
			'HS_HousingColour',
			'HS_HousingCoating',
			'LE_OpticalVersion_1',
			'LE_LightDistribution_1',
			'LE_OpticalVersion_1',
			'LE_ColourTemperature_1',
			'HS_Base',
			'LE_LightEngineModuleSize_1',
			'HS_HousingPowerConnection',
			'LE_DimmingLevel_1',
			'LE_LightEngineModuleSize_1',
			'EB_ConstantLumenTechnology_1',
			'EB_ControlNoWire_1',
			'EB_ControlWire_1',
			'EB_Wattage_1',
			'HS_HousingSize',
			'HS_ColourPriceCategory',
			'HS_HousingPowerConnection',
			'HS_HousingZhaga',
			'LE_LuminousFlux_1',
			'LE_ReflectorColour_1',
			'HS_CircularBaseProfile',
			'LE_LightEngineModuleSize_1'
			*/
		],
		widgets: [
			html`
				<model-select></model-select>`
		]
	},
];

// show widgets on desktop, but hide on mobile
const lightProfileWidgets = {
	desktop: [
		html`
			<list-select
				.title=${{de: 'Wählen Sie ein Lichtprofil', en: 'Choose a light profile', fr: 'Choisir un profil lumineux'}}
				.options=${baseProfileOptions}
				action='lightProfile/setBaseProfileId'
				.selected=${selectBaseProfile}
				.isSatisfied=${selectBaseProfileIsSatisfied}></list-select>`,
		html`
			<list-select
				.title=${{de: 'Wählen Sie die Zone', en: 'Choose a zone', fr: 'Choisir une zone'}}
				.options=${zoneOptions}
				action='lightProfile/setZoneId'
				.selected=${selectZone}
				.isSatisfied=${selectZoneIsSatisfied}></list-select>`,
		html`
			<list-select
				.title=${{de: 'Zentrale Steuerung', en: 'Central control', fr: 'Central control'}}
				.options=${centralPowerControlOptions}
				action='lightProfile/setCentralPowerControlId'
				.selected=${selectCentralPowerControl}
				.canBeSelected=${() => true}
				.isSatisfied=${selectCentralPowerControlIsSatisfied}></list-select>`,
		html`
			<location-select
				.action=${fetchLightProfileLocation}
				.selectedLocation=${selectLightProfileLocation}
				.isSatisfied=${selectLightProfileLocationIsSatisfied}></location-select>`,
		html`
			<text-input
				.title=${{de: 'Projektname', en: 'Project name', fr: 'Nom du projet'}}
				.text=${selectProjectName}
				action='lightProfile/setProjectName'></text-input>`,
	],
	mobile: []
};

const MediaQuery = window.matchMedia('(max-width: 767px)');

const lightProfileWidgetsToShow = MediaQuery.matches ? lightProfileWidgets.mobile : lightProfileWidgets.desktop;

// section configuration
// used in statusSlice
export const lightProfile = [
	{
		id: 'base',
		label: {
			de: 'Konfigurator',
			en: 'Configurator',
			fr: 'Configurator',
		},
		visual: 'lightprofilebase',
		features: [],
		isSatisfied: selectBaseProfileIsSatisfied,
		attributeOptions: {
			'root::CX_Region': {
				hidden: true
			}
		},
		widgets: [
			html`
				<list-select
					.title=${{de: 'Wählen Sie ein Lichtprofil', en: 'Choose a light profile ', fr: 'Choisir un profil lumineux'}}
					.options=${baseProfileOptions}
					action='lightProfile/setBaseProfileId'
					.selected=${selectBaseProfile}
					.canBeSelected=${() => true}
					.isSatisfied=${selectBaseProfileIsSatisfied}></list-select>`,
		]
	},
	{
		id: 'zone',
		label: {
			de: 'Umgebung',
			en: 'Zone',
			fr: 'Zone',
		},
		visual: 'lightprofilezone',
		features: [],
		isSatisfied: selectZoneIsSatisfied,
		widgets: [
			html`
				<list-select
					.title=${{de: 'Wählen Sie die Zone', en: 'Choose a zone', fr: 'Choisir une zone'}}
					.options=${zoneOptions}
					action='lightProfile/setZoneId'
					.selected=${selectZone}
					.canBeSelected=${() => true}
					.isSatisfied=${selectZoneIsSatisfied}></list-select>`,
		]
	},
	{
		id: 'location',
		label: {
			de: 'Ort',
			en: 'Location',
			fr: 'Localisation',
		},
		visual: 'lightprofilelocation',
		features: [],
		isSatisfied: selectLightProfileLocationIsSatisfied,
		widgets: [
			html`
				<location-select
					.action=${fetchLightProfileLocation}
					.selectedLocation=${selectLightProfileLocation}
					.isSatisfied=${selectLightProfileLocationIsSatisfied}
				></location-select>`,
		]
	},
	{
		id: 'lightprofile',
		label: {
			de: 'Anwendung',
			en: 'Application',
			fr: 'Application',
		},
		visual: 'lightprofile',
		features: [],
		isSatisfied: state => selectBaseProfileIsSatisfied(state) && selectZoneIsSatisfied(state) && selectLightProfileLocationIsSatisfied(state),
		widgets: lightProfileWidgetsToShow
	},
	{
		id: 'luminaire',
		label: {
			de: 'Leuchte',
			en: 'Luminaire',
			fr: 'Luminaire',
		},
		visual: 'lightprofileluminary',
		features: [
			'ModelSelect',
			'root::HS_HousingColour',
			'root::LE_OpticalVersion_1',
			'root::LE_LightDistribution_1',
			'root::HS_HousingSize',
			'root::HS_Base',
			'root::LE_LightEngineModuleSize_1',
			'root::LE_ColourTemperature_1',

			'root::HS_CircularBaseProfile',

			'root::HS_LightEmission',
			'root::EB_ElectricalProtectionClass_1',
			'root::HS_HousingPowerConnection',
			'root::LE_DimmingLevel_1',

			// 'root::CX_Region',
			'root::HS_ColourPriceCategory',
			'root::HS_HousingCoating',
			'root::HS_HousingZhaga',
			'root::LE_ReflectorColour_1',
			'root::LE_LuminousFlux_1',
			'root::EB_ConstantLumenTechnology_1',
			//'root::EB_ControlNoWire_1',
			//'root::EB_ControlWire_1',
			'root::EB_Wattage_1',
			'root::EB_Zhaga_1',
			// 'root::LU_LegacyArticleNumberGerman',

			//'root::HS_HousingHeight',
			//'root::HS_HousingShape',
			//'root::HS_HousingType',
		],
		isSatisfied: selectLightProfileIsSatisfied,
		widgets: [
			html`
				<list-select
					.title=${{de: 'Leuchte', en: 'Luminary', fr: 'Luminaire'}}
					.options=${luminaryOptions}
					action='lightProfile/setLuminaryId'
					.selected=${selectLuminary}
					.hideDisabled=${true}
					.canBeSelected=${(s, value) =>
						luminaryOptions.find(o => o.id === value).availableForLightProfiles.includes(s.lightProfile.data.project.base)}
					.isSatisfied=${selectLuminaryIsSatisfied}></list-select>`
		]
	},
	{
		id: 'summary',
		label: {
			de: 'Zusammenfassung',
			en: 'Summary',
			fr: 'résumé',
		},
		visual: 'lightProfileSummary',
		features: [],
		isSatisfied: () => true,
		widgets: [],
		theme: 'darkTheme'
	},
	{
		id: 'specsheet',
		label: {
			de: 'Datenblatt',
			en: 'Specsheet',
			fr: 'Specsheet',
		},
		visual: 'specsheet',
		features: [],
		isSatisfied: () => true,
		widgets: null,
		theme: 'lightTheme',
		notInDashboard: true,
		simpleNavigation: true,
		notInNavigation: true,
	},
	{
		id: 'finalize',
		label: {
			de: 'Abschließen',
			en: 'Finalize',
			fr: 'Finalize',
		},
		visual: 'finalize',
		features: [],
		isSatisfied: () => true,
		widgets: [
			html`

			`
		],
		theme: 'lightTheme',
		notInDashboard: true,
		noNavigation: true,
		notInNavigation: true,
	},
];

